<template>
    <div class="pro_container">
        <!-- 头部 -->
        <v-header2></v-header2>
        <!-- 产品标题 -->
        <product-tool title="A10" color="#ffffff"></product-tool>
        <!-- 产品图片 -->
        <img class="pro_img" src="https://wx3.sinaimg.cn/large/0067mezugy1g9krtozk4vj31hc0u0jv8.jpg"/>
        <img class="pro_img" src="https://wx1.sinaimg.cn/large/0067mezugy1g9krtrxog2j31hc0u0ac2.jpg"/>
        <img class="pro_img" src="https://wx2.sinaimg.cn/large/0067mezugy1g9krtuqhtej31hc0u041m.jpg"/>
        <img class="pro_img" src="https://wx1.sinaimg.cn/large/0067mezugy1g9krtyigtgj31hc0u0dio.jpg"/>
        <img class="pro_img" src="https://wx2.sinaimg.cn/large/0067mezugy1g9kru1ms2hj31hc0u0whv.jpg"/>
        <img class="pro_img" src="https://wx3.sinaimg.cn/large/0067mezugy1g9kru9emqdj31hc0u0djt.jpg"/>
        <img class="pro_img" src="https://wx1.sinaimg.cn/large/0067mezugy1g9krucv8dkj31hc0u0di1.jpg"/>
        <img class="pro_img" src="https://wx1.sinaimg.cn/large/0067mezugy1g9krufilq6j31hc0u0q5b.jpg"/>
        <img class="pro_img" src="https://wx2.sinaimg.cn/large/0067mezugy1g9kruid5j5j31hc0u0dks.jpg"/>
        <img class="pro_img" src="https://wx2.sinaimg.cn/large/0067mezugy1gdwj6lev0cj31hc0u0aco.jpg"/>
        <img class="pro_img_mb" src="https://wx1.sinaimg.cn/large/0067mezugy1g9krxc8ytgj30ku112abu.jpg"/>
        <img class="pro_img_mb" src="https://wx4.sinaimg.cn/large/0067mezugy1g9krxf601pj30ku112jsr.jpg"/>
        <img class="pro_img_mb" src="https://wx3.sinaimg.cn/large/0067mezugy1g9krxhwm3tj30ku112zmc.jpg"/>
        <img class="pro_img_mb" src="https://wx1.sinaimg.cn/large/0067mezugy1g9krxlve1oj30ku11240g.jpg"/>
        <img class="pro_img_mb" src="https://wx4.sinaimg.cn/large/0067mezugy1g9krxpeu4zj30ku112q5f.jpg"/>
        <img class="pro_img_mb" src="https://wx3.sinaimg.cn/large/0067mezugy1g9krxwgm4sj30ku112tbw.jpg"/>
        <img class="pro_img_mb" src="https://wx2.sinaimg.cn/large/0067mezugy1g9krxzmj00j30ku112dhe.jpg"/>
        <img class="pro_img_mb" src="https://wx4.sinaimg.cn/large/0067mezugy1g9kry37x14j30ku112tab.jpg"/>
        <img class="pro_img_mb" src="https://wx4.sinaimg.cn/large/0067mezugy1g9kry666l1j30ku112q69.jpg"/>
        <img class="pro_img_mb" src="https://wx1.sinaimg.cn/large/0067mezugy1gdzgthto0tj30ku112tax.jpg"/>
        <v-footer2></v-footer2>
    </div>
</template>

<script>
export default {
    data(){
        return {
           
        }
    },
    methods:{
    }
}
</script>
<style scoped>

.pro_animation .pro_colors i:nth-child(1){
	background-image: url(../../../assets/img/n/pa_1.png);
}

.pro_animation .pro_colors i:nth-child(2){
	background-image: url(../../../assets/img/n/pa_2.png);
	margin-left: 40px;
}
</style>



// WEBPACK FOOTER //
// src/pages/products/A/a10.vue